import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Truck, Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export const SpedisciSettingsCard = () => {
  const [status, setStatus] = useState(null);
  const [clientId, setClientId] = useState("");
  const [secret, setSecret] = useState("");
  const [saving, setSaving] = useState(false);
  const [contracts, setContracts] = useState(null);

  const load = () => api.get("/gls/settings").then((r) => setStatus(r.data)).catch(() => setStatus({ configured: false }));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!clientId.trim() || !secret.trim()) return toast.error("Inserisci Client ID e Client Secret");
    setSaving(true);
    try {
      await api.put("/gls/settings", { client_id: clientId, client_secret: secret });
      toast.success("Credenziali Spedisci.online salvate e verificate");
      setClientId(""); setSecret("");
      load();
      const r = await api.get("/gls/check");
      setContracts(r.data.contracts);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="spedisci-settings-card">
      <CardContent className="p-6 space-y-4">
        <div className="flex flex-wrap items-center gap-3">
          <div className="p-3 bg-yellow-50 rounded-xl"><Truck className="w-6 h-6 text-yellow-700" /></div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900">Spedisci.online · Etichette GLS</h3>
            <p className="text-sm text-gray-500">Credenziali dalla pagina "API App" del tuo pannello</p>
          </div>
          {status && (status.configured
            ? <span className="text-xs text-green-700 flex items-center gap-1" data-testid="spedisci-status-ok"><CheckCircle2 className="w-4 h-4" />Collegato {status.client_id_hint}</span>
            : <span className="text-xs text-orange-600 flex items-center gap-1" data-testid="spedisci-status-missing"><AlertCircle className="w-4 h-4" />Da configurare</span>)}
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <Input placeholder="Client ID" value={clientId} onChange={(e) => setClientId(e.target.value)} autoComplete="off" data-testid="spedisci-client-id-input" />
          <Input placeholder="Client Secret" type="password" value={secret} onChange={(e) => setSecret(e.target.value)} autoComplete="new-password" data-testid="spedisci-client-secret-input" />
        </div>
        <Button onClick={save} disabled={saving} className="bg-[#C9A227] hover:bg-[#b08d1f] text-white" data-testid="spedisci-save-btn">
          {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Verifica e salva
        </Button>
        {contracts && (
          <div className="text-sm text-gray-600" data-testid="spedisci-contracts">
            {contracts.length ? contracts.map((c) => <div key={c.contract}>{c.contract}: €{c.price} (1 kg)</div>) : "Nessun contratto disponibile"}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
